import { createContext, useContext } from "react";

import { type RouterContextInterface } from "./types";

export const RouterContext = createContext<RouterContextInterface | null>(null);

export const useRouterContext = () => useContext(RouterContext);
